import React from "react";
import { useSelector } from "react-redux";
import { CLIENTES_IDS, PAGINA_DETALLE } from "../../../constants/cons";
import { Archivos } from "./archivos/Archivos";
import { Historial } from "./hisotiral/Historial";
import { Mapa } from "./mapa/Mapa";
import { Proveedor } from "./proveedor/Proveedor";
import Chat from "./chat/Chat";
import AddLlamada from "./llamadas/AddLlamada";
import { FotosServicio } from "./fotos/FotosServicio";
import { ComunicacionSMS } from "./sms/ComunicacionSMS.jsx";
import { Edega } from "./edega/Edega";


export const CuerpoDetalle = () => {
  const { folderPagina, asistencia } = useSelector((state) => state.detalleReducer);
  const clienteID = asistencia.asegurado?.campania?.clienteID;
  if (folderPagina === PAGINA_DETALLE.proveedor) return <Proveedor />
  if (folderPagina === PAGINA_DETALLE.mapa) return <Mapa />
  if (folderPagina === PAGINA_DETALLE.archivos) return <Archivos />
  if (folderPagina === PAGINA_DETALLE.hisotrial) return <Historial />
  if (folderPagina === PAGINA_DETALLE.chat) return <Chat />
  if (folderPagina === PAGINA_DETALLE.llamadas) return <AddLlamada />
  if (folderPagina === PAGINA_DETALLE.fotos) return <FotosServicio />
  if (folderPagina === PAGINA_DETALLE.sms) return <ComunicacionSMS />
  if (folderPagina === PAGINA_DETALLE.edega && (clienteID === CLIENTES_IDS.EDEGA || clienteID === CLIENTES_IDS.EDEGA_PROD || clienteID === CLIENTES_IDS.EDEGA_QA)) return <Edega />
  // if (folderPagina === PAGINA_DETALLE.placas) return <UploadPlacas />


  return <>Err</>;
};
